module.exports = __webpack_public_path__ + "img/wfkxt.93207947.jpg";